import { formatMessage as f } from '@/i18n';

const ERRORMSG = {
  // TODO: 加入未启动SDK时的错误
  // TODO: 加入锁匠码不匹配的错误
  SERIAL_NOT_OPEN: 'Serial port is closed.',
  SOCKET_CONNECTING: 'Socket is still connecting',
  SOCKET_DISCONNECTED: 'Socket is not connected',
  SOCKET_HAS_CONNECTED: 'Socket has connected',
  FAILED_TO_CNNECT_SOCKET: 'Failed to connect socket',

  SOCKET_BUSY: 'Socket is busy',

  SDK_NOT_ACTIVE: 'The sdk is not active.',
  SDK_EXPIRED: 'The api expire.',

  // WRONG_CODE: 'Failed to verify',
  WRONG_CODE: '(VerifyCodes)Failed to verify codes',

  KEY_NOT_CONNECT: 'Failed to create NFC connection.Detail:(Encoder)Length code is wrong.',
  KEY_NOT_CONNECT2:
    'Failed to create NFC connection.Detail:(Encoder)Failed to read data from COM buffer.', // 这个貌似是真真正的钥匙未连接的提示
  KEY_NOT_CONNECT3: 'Failed to create NFC connection.Detail:(Encoder)The result is failure.',
  KEY_NOT_CONNECT4:
    'Failed to verify syscode444.Detail:(NFCKey)Failed to connect NFC key.|(Encoder)Failed to read data from COM buffer.',

  // TODO: 上述的钥匙未连接错误暂不清楚是否可靠，只用下面这个第五种情况判断；
  KEY_NOT_CONNECT5: 'There is no key connected with encoder:(Encoder)The result is failure.',

  UNKNOWS: [
    'Failed to verify syscode444.Detail:(NFCKey)The result is failure.',
    'Failed to create NFC connection.Detail:(Encoder)Head code is wrong.',
    'Failed to verify regcode222.Detail:(NFCKey)Head code is wrong.',
    "Failed to read key's factory number.Detail:(NFCKey)Length code is wrong.",
    'Failed to verify regcode222.Detail:(NFCKey)Failed to connect NFC key.|(Encoder)Failed to read data from COM buffer.',
    'Failed to create NFC connection.Detail:(Encoder)recvData or pucRecvDataLen is NULL.',
  ],
};

const EXCEPTIONS = {
  // SERIAL_NOT_OPEN: '接口通讯失败，请检查发卡器连接',
  // SOCKET_CONNECTING: '通讯接口初始化中，请稍后重试',
  // SOCKET_DISCONNECTED: '通讯接口尚未启动，请稍后重试',
  // SOCKET_HAS_CONNECTED: '通讯接口已启动，无需重复启动',
  // FAILED_TO_CNNECT_SOCKET: '连接通讯接口时出错，请检查其安装启动状态',

  // SOCKET_BUSY : '通讯繁忙中，请稍后重试...',

  // SDK_NOT_ACTIVE: '通讯组件尚未注册，请稍后重试',
  // SDK_EXPIRED: '通讯组件注册过期，请刷新页面重试',

  // KEY_NOT_CONNECT: '钥匙未连接',
  // KEY_NOT_CONNECT2: '钥匙未连接',
  // KEY_NOT_CONNECT2: '钥匙未连接',

  SERIAL_NOT_OPEN: f('hardware.serial.not.open'),
  SOCKET_CONNECTING: f('hardware.socket.connecting'),
  SOCKET_DISCONNECTED: f('hardware.socket.disconnected'),
  SOCKET_HAS_CONNECTED: f('hardware.socket.has.connected'),
  FAILED_TO_CNNECT_SOCKET: f('hardware.failed.to.connect.socket'),

  SOCKET_BUSY: f('hardware.socket.busy'),

  SDK_NOT_ACTIVE: f('hardware.sdk.not.active'),
  SDK_EXPIRED: f('hardware.sdk.expired'),

  WRONG_CODE: f('hardware.sdk.code.unmatch'),

  KEY_NOT_CONNECT: f('hardware.not.connect'),
  KEY_NOT_CONNECT2: f('hardware.not.connect'),
  // KEY_NOT_CONNECT2: f('hardware.not.connect'),

  KEY_NOT_CONNECT5: f('hardware.not.connect'),
};

export const transformException = errBody => {
  let returnMsg = '';
  const errMsg = errBody.error;
  // TODO:这里也可以采用遍历错误对象数组的方式，进行错误匹配，优先返回相等，首部匹配次之，包含再次之
  if (errMsg.includes(ERRORMSG.SERIAL_NOT_OPEN)) returnMsg = EXCEPTIONS.SERIAL_NOT_OPEN;
  else if (errMsg.includes(ERRORMSG.SOCKET_CONNECTING)) returnMsg = EXCEPTIONS.SOCKET_CONNECTING;
  else if (errMsg.includes(ERRORMSG.SOCKET_DISCONNECTED))
    returnMsg = EXCEPTIONS.SOCKET_DISCONNECTED;
  else if (errMsg.includes(ERRORMSG.SOCKET_HAS_CONNECTED))
    returnMsg = EXCEPTIONS.SOCKET_HAS_CONNECTED;
  else if (errMsg.includes(ERRORMSG.FAILED_TO_CNNECT_SOCKET))
    returnMsg = EXCEPTIONS.FAILED_TO_CNNECT_SOCKET;
  else if (errMsg.includes(ERRORMSG.SOCKET_BUSY)) returnMsg = EXCEPTIONS.SOCKET_BUSY;
  else if (errMsg.includes(ERRORMSG.SDK_NOT_ACTIVE)) returnMsg = EXCEPTIONS.SDK_NOT_ACTIVE;
  else if (errMsg.includes(ERRORMSG.SDK_EXPIRED)) returnMsg = EXCEPTIONS.SDK_EXPIRED;
  else if (errMsg.includes(ERRORMSG.WRONG_CODE)) returnMsg = EXCEPTIONS.WRONG_CODE;
  // else if (errMsg.includes(ERRORMSG.KEY_NOT_CONNECT)) returnMsg = EXCEPTIONS.KEY_NOT_CONNECT
  // else if (errMsg.includes(ERRORMSG.KEY_NOT_CONNECT2)) returnMsg = EXCEPTIONS.KEY_NOT_CONNECT2
  // else if (errMsg.includes(ERRORMSG.KEY_NOT_CONNECT3)) returnMsg = EXCEPTIONS.KEY_NOT_CONNECT3
  else if (errMsg.includes(ERRORMSG.KEY_NOT_CONNECT5)) returnMsg = EXCEPTIONS.KEY_NOT_CONNECT5;
  // else returnMsg = f('hardware.unknown.error') + errMsg
  else returnMsg = f('hardware.unknown.error');
  console.log(returnMsg);
  return returnMsg;
};
